// Copyright (c) 2016 Deere & Company

import ClaimAction, {getDefaultState as getClaimActionDefaultState} from './claim-action';
import ClaimAdditionalFailureInfo, {getDefaultState as getClaimAdditionalFailureInfoDefaultState} from './claim-additional-failure-info';
import ClaimComplaintCause, {getDefaultState as getClaimComplaintCauseDefaultState} from './claim-complaint-cause';
import ClaimFailureInfo, {getDefaultState as getClaimFailureInfoDefaultState} from './claim-failure-info';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReferenceInfo, {getDefaultState as getClaimReferenceInfoDefaultState} from './claim-reference-info';
import ClaimReimbursementDetails, {getDefaultState as getClaimReimbursementDetailsDefaultState} from './claim-reimbursement-details';
import ClaimRgaStatus, {getDefaultState as getClaimRgaStatusDefaultState} from './claim-rga-status';
import ClaimRules, {getDefaultState as getClaimRulesDefaultState} from './claim-rules';
import ClaimSpecialAllowanceCalculations, {getDefaultState as getClaimSpecialAllowanceCalculationsDefaultState} from './claim-special-allowance-calculation';
import ClaimUseAmount, {getDefaultState as getClaimUseAmountDefaultState} from './claim-use-amount';
import ClaimValueOfRepair, {getDefaultState as getClaimValueOfRepairDefaultState} from './claim-value-of-repair';
import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ClaimLabor from './claim-item-labor';
import ClaimOtherCredit from './claim-item-other-credit';
import ClaimPart from './claim-item-part';
import ClaimVsrMessage from './claim-vsr-message';
import File from './file';
import t from 'tcomb';

const ClaimSpecialAllowance = t.struct({
    additionalFailureInfo: ClaimAdditionalFailureInfo,
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    complaintCauseCommentsBasis: ClaimComplaintCause,
    customerSummary: CustomerSummary,
    errors: t.list(ClaimVsrMessage, 'Errors'),
    failureInfo: ClaimFailureInfo,
    file: t.maybe(t.list(File, 'Files')),
    goodsInstallationVat: t.maybe(KeyValuePair),
    isDuplicateClaim: t.Bool,
    isEditable: t.Bool,
    labor: t.maybe(t.list(ClaimLabor, 'Labor')),
    model: t.String,
    otherCredits: t.maybe(t.list(ClaimOtherCredit, 'OtherCredits')),
    parts: t.maybe(t.list(ClaimPart, 'Parts')),
    pin: t.String,
    previousInvoiceNumber: t.String,
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimReferenceInfo,
    reimbursementDetails: ClaimReimbursementDetails,
    responsibleAccount: Dealer,
    retailInstallDate: t.maybe(t.Number),
    rgaStatus: ClaimRgaStatus,
    rules: ClaimRules,
    selectedAction: ClaimAction,
    serialNumber: t.String,
    showAmountsInLocalCurrency: t.Bool,
    showGoodsInstallationVat: t.Bool,
    showValidate: t.Bool,
    specialAllowanceCalculations: ClaimSpecialAllowanceCalculations,
    specialAllowanceType: KeyValuePair,
    useAmount: ClaimUseAmount,
    validationFailed: t.Bool,
    valueOfRepairList: ClaimValueOfRepair,
    valueOfRepairNet: ClaimValueOfRepair,
    version: t.String
}, {
    name: 'ClaimSpecialAllowance',
    strict: true
});

export const getDefaultState = () => new ClaimSpecialAllowance({
    additionalFailureInfo: getClaimAdditionalFailureInfoDefaultState(),
    allowedActions: [
        new ClaimAction({
            actionName: 'DRAFT',
            id: 'DRAFT',
            mode: 'CHG'
        })
    ],
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: new KeyValuePair({
        key: 'ZSPA',
        value: ''
    }),
    complaintCauseCommentsBasis: getClaimComplaintCauseDefaultState(),
    customerSummary: getCustomerSummaryDefaultState(),
    errors: [],
    failureInfo: getClaimFailureInfoDefaultState(),
    file: [],
    goodsInstallationVat: getKeyValuePairDefaultState(),
    isDuplicateClaim: false,
    isEditable: true,
    labor: [],
    model: '',
    otherCredits: [],
    parts: [],
    pin: '',
    previousInvoiceNumber: '',
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: getClaimReferenceInfoDefaultState(),
    reimbursementDetails: getClaimReimbursementDetailsDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    retailInstallDate: null,
    rgaStatus: getClaimRgaStatusDefaultState(),
    rules: getClaimRulesDefaultState(),
    selectedAction: getClaimActionDefaultState(),
    serialNumber: '',
    showAmountsInLocalCurrency: false,
    showGoodsInstallationVat: false,
    showValidate: true,
    specialAllowanceCalculations: getClaimSpecialAllowanceCalculationsDefaultState(),
    specialAllowanceType: getKeyValuePairDefaultState(),
    useAmount: getClaimUseAmountDefaultState(),
    validationFailed: false,
    valueOfRepairList: getClaimValueOfRepairDefaultState(),
    valueOfRepairNet: getClaimValueOfRepairDefaultState(),
    version: ''
});

ClaimSpecialAllowance.prototype.vsrErrorMessages = function vsrErrorMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'E');

    return errorMessages;

};

ClaimSpecialAllowance.prototype.vsrWarningMessages = function vsrWarningMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'W');

    return errorMessages;

};

ClaimSpecialAllowance.prototype.vsrInfoMessages = function vsrInfoMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'I');

    return errorMessages;

};

export default ClaimSpecialAllowance;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-special-allowance.js